// extracted by mini-css-extract-plugin
export default {"criticalSection":"styles_criticalSection__lEvKU","label":"styles_label__XERWw","filledIcon":"styles_filledIcon__mKsv7"};